export enum ClaimType {
    LWR = 1,
    DER = 2
}